const parseNumber = (value, radix = 10) =>
  (value && parseInt(value, radix)) || 0;

export default parseNumber;
